/* eslint-disable */
import { IllustrationOutput } from '@/common/ModelOutputs2202';
import { UserInputs, UserRetirementOptions, UserAccumulationOptions, UserAccumulationIllustration } from '@/common/UserInputs2202';
import { user } from '@/observables/UserDetails';
import { faLoveseat } from '@fortawesome/pro-regular-svg-icons';
import moment, { max, Moment } from 'moment';

const version = '2.0';

const prososedDateOfImplementation = new Date(2023, 9, 30);
const transitionalDateComparitor = new Date(2012, 4, 1);

const piro2022 = 0.047;

const assumptions = {
    inflation: 0.025,
    careExcessIncreases: 0.016,
    drawdown: 0.01,
    salInc2022TPS: 0.01,
    salInc2022GDST: 0.05,
    earlyAdoptionBonus: 2000,
    salInc2023TPS: 0.01,
    salInc2023GDST: 0.01,
};

const taxCalcParams = {
    personalAllowance: 12500,
    basicRateLimit: 37500,
    basicRate: 0.2,
    higherRateLimit: 150000,
    higherRate: 0.4,
    additionalRate: 0.45,
    personalAllowanceReducedFrom: 100000,
    personalAllowanceReducedRate: 0.5,
};

const niCalcParams = {
    threshold: 9500,
    upperBand: 50000,
    bandRate: 0.12,
    higherRate: 0.02,
};

let spd = null;
let dob = null;

const erf_80ths_npa60 = [1, 0.959, 0.918, 0.88, 0.845, 0.811];
const erf_60ths_npa65 = [1, 0.95, 0.902, 0.858, 0.817, 0.779, 0.744, 0.711, 0.681, 0.652, 0.625]; // also used for active
const erf_care_deferred = [1, 0.947, 0.897, 0.851, 0.808, 0.769, 0.732, 0.699, 0.667, 0.638, 0.61, 0.585, 0.561, 0.538]; // from NPA

const lrf_60ths_npa65_preNPAservice = [1, 1.035, 1.071, 1.11, 1.153, 1.2, 1.252, 1.308, 1.371, 1.439, 1.511]; //65 to 75
const lrf_care_active = [1, 1.041, 1.083, 1.130, 1.18, 1.235, 1.296, 1.363, 1.436, 1.516, 1.601]; //65 to 75

const annuity_Factors = [[63.0052311716854,60.7343582570042,58.5103930550774,56.3325699281647,54.2005938149624,52.1144741346793,50.074178804359,48.0796329083352,46.1308047986213,44.2275909902931,42.3698058109294,40.5572141548549,38.7895534745052,37.0665274929413,35.3878305921809,33.7531600204374,32.1622361474818,30.6148277875624,29.1107697211238,27.6499829163301,26.2324657591715],[62.8278274747141,60.561912780886,58.3427632897829,56.169619367338,54.0421962813249,51.9605163866626,49.9245596569398,47.9342626603986,45.9896054100086,44.0904950178066,42.236755204127,40.4281594585482,38.6644531963432,36.9453474259559,35.2705434109669,33.6397450026767,32.0526791369333,30.5091213748303,29.0089135648129,27.551984242327,26.1383397013353],[62.6498511069583,60.3889161387608,58.1746030624733,56.0061582924305,53.883307502245,51.8060860854063,49.7744861635911,47.7884558639597,45.8479869522657,43.9529972155393,42.1033198327383,40.2987369452002,38.5390019815978,36.8238332824494,35.152939024118,33.5260297109072,31.9428388696463,30.4031488401411,28.9068086054222,27.453754278412,26.0440001003387],[62.4713046933788,60.2153709428127,58.0059149660263,55.8421892738806,53.7239300318591,51.6511857596984,49.6239608249115,47.6422150002527,45.7059518819855,43.8151000210355,41.9695021114288,40.1689490155767,38.4132022150963,36.701987425395,35.035019787748,33.4120164822202,31.8327176662631,30.2969124994385,28.8044571282878,27.3552952898138,25.9494492116569],[62.2921904931193,60.0412794429969,57.8367012455716,55.677714551895,53.5640660943545,51.4958176252354,49.47298583711,47.4955422479064,45.5635023746642,43.6768055931904,41.8353041882356,40.0387977839197,38.2870559828018,36.5798119332363,34.9167877502588,33.2977073434056,31.7223175266055,30.1904143336168,28.7018610966584,27.2566092212545,25.8546889587318],[62.1125114882749,59.8666445973378,57.6669648308587,55.5127370249048,53.4037185599671,51.3399845207697,49.321564016395,47.3484403919968,45.4206411748388,43.5381166428156,41.7007287345318,39.9082859125949,38.1605659328016,36.4573094066924,34.7982454953759,33.1831048496252,31.6116409960405,30.0836568557393,28.5990229906496,27.1576985144081,25.759721743638],[61.9322708278003,59.6914695310063,57.496708819855,55.3472597567017,53.2428904601607,51.1836894449211,49.1696983325682,47.2009123653462,45.2773711756226,43.3990360326145,41.5657785925421,39.7774161950146,38.0337348176466,36.3344825842006,34.6793957195031,33.0682116681892,31.5006906976832,29.9766426558634,28.495945372322,27.0585657190117,25.6645500993592],[61.7514710227082,59.5157567412211,57.3259356943714,55.181285224763,53.0815842578406,51.0269348411406,49.0173911994339,47.0529605702352,45.1336947699956,43.2595661374152,41.4304561017139,39.6461909581117,37.9065649454545,36.211333737957,34.5602406696788,32.9530300206785,31.3894688287333,29.8693738991868,28.3926303740965,26.9592129127428,25.5691760586212],[61.570115374172,59.3395094953905,57.1546486870789,55.0148166120747,52.9198030992955,50.8697238208185,48.8646456913336,46.9045880325001,44.989614943693,43.1197098914141,41.2947641692461,39.5146130681981,37.7790591402378,36.0878656643988,34.440783120239,32.8375626546919,31.2779781000856,29.7618532765401,28.2890806688478,26.8596427529843,25.4736022435151],[61.3882067451155,59.1627306347301,56.9828506145447,54.8478567130466,52.7575497399677,50.7120591053166,48.7114645046629,46.7557974244218,44.845134333061,42.9794699165699,41.1587053791061,39.3826850791075,37.6512199336119,35.96408085685,34.3210255217576,32.7218119727672,31.1662208893471,29.6540831220105,28.1852985467035,26.7598574953736,25.3778308924908],[61.205748579185,58.9854235709132,56.8105448520313,54.6804088757306,52.5948275017411,50.5539439846637,48.5578508826177,46.6065919466751,44.7002560962148,42.8388493253199,41.0222828129469,39.2504100333597,37.5230503218386,35.8399822836256,34.2009708146848,32.6057808876212,31.0542000687505,29.5460662855635,28.0812868158702,26.6598598985342,25.2818647165834],[61.0227445857229,58.8075919681691,56.6377350227998,54.5124766666605,52.4316399047401,50.395381923994,48.4038082521424,46.4569749820457,44.5549835827056,42.6978514196645,40.8854997207759,39.1177911334075,37.3945534697171,35.7155730555555,34.0806220581605,32.4894724176427,30.9419186087667,29.4378056711528,27.9770483377837,26.5596527860646,25.1857064690177],[60.8391972775481,58.6292383269049,56.4644236036164,54.3440625468327,52.2679893809424,50.236375339738,48.249339001,46.30694889682,44.4093191245087,42.5564785043768,40.7483583838336,38.9848306432709,37.265731608782,35.5908553875425,33.959981436653,32.3728887186824,30.8293786393285,29.3293033870549,27.8725851893258,26.4592381939538,25.0893581803721],[60.6551109553861,58.4503668928842,56.2906148003968,54.175170665766,52.1038800366687,50.0769282771198,48.0944471173553,46.156517611911,44.2632665825186,42.4147343902012,40.6108625493548,38.8515322487401,37.1365883783104,35.4658328496047,33.8390524773629,32.256033256932,30.7165835795144,29.2205628039858,27.7679006917102,26.3586193899151,24.9928230530191],[60.4704887322943,58.2709807501543,56.1163116443868,54.0058040188764,51.9393148103875,49.9170436409514,47.939135472754,46.0056839745621,44.1168287759824,42.2726218514961,40.4730149718455,38.7178986682066,37.0071264452109,35.3405080888727,33.7178377841235,32.1389086014964,30.6035359459429,29.1115863922725,27.6629972696895,26.257798771322,24.8961034373862],[60.2853350365463,58.0910842627823,55.9415184564629,53.8359668692687,51.774297921479,49.7567255829571,47.7834081507112,45.8544519850248,43.9700096362356,42.1301447650999,40.3348194514929,38.5839336352844,36.8773495000838,35.2148847250744,33.5963409126992,32.0215182471641,30.4902391888103,29.002377551302,27.5578782598626,26.1567795919818,24.7992025203173],[60.0996528943021,57.9106804392344,55.7662381979693,53.665662147889,51.6088322643689,49.5959769707376,47.6272679880716,45.7028244701554,43.822811959621,41.9873058859493,40.1962787115241,38.4496398467061,36.747260194366,35.0889653721125,33.474564447289,31.9038647493527,30.376695811137,28.892938734096,27.4525460790507,26.0555642392426,24.7021226528511],[59.9134464931921,57.7297734010921,55.59047495197,53.4948938803878,51.4429218074562,49.434801713392,47.4707188352267,45.5508052114753,43.6752394677256,41.8441088833338,40.0573963729568,38.3150208690904,36.6168620408965,34.9627535010333,33.3525118009765,31.785951455674,30.2629091201822,28.7832731935077,27.3470039237776,25.9541558529626,24.6048669231626],[59.7267203535481,57.5483676181637,55.4142331219205,53.3236664007609,51.2765708182663,49.2732040086352,47.3137648207482,45.3983982715712,43.5272961585488,41.700557689487,39.9181762946821,38.1800804836585,36.4861587548852,34.8362527493913,33.230186543568,31.667781870328,30.1488825365027,28.6733842895686,27.2412550755471,25.8525576336533,24.5074384347123],[59.5394777412378,57.3664665790182,55.2375162117357,53.1519831676779,51.1097826990537,49.1111872194337,47.1564092716292,45.2456069258606,43.3789852582133,41.5566554866134,39.7786216140155,38.0448217955968,36.355153396561,34.7094661311863,33.107591652657,31.5493589324894,30.0346189557806,28.5632748662539,27.1353023409948,25.7507723422793,24.4098399131736],[59.3517182152092,57.184073641604,55.060328162559,52.9798484140346,50.9425617252861,48.9487555521666,46.9986563220818,45.0924352540669,43.2303107816864,41.4124062183281,39.6387362074547,37.9092486064398,36.2238497030267,34.5823973286895,32.9847307334244,31.4306861785376,29.9201218589788,28.4529483440665,27.0291490680444,25.6488032637634,24.3120745731039],[59.1633958265941,57.0011716979615,54.8826675270007,52.8072651089087,50.7749114672675,48.7859128775922,46.8405098672949,44.9388870849709,43.0812764982684,41.2678135972939,39.4985237296815,37.7733645219534,36.0922512243351,34.4550498235953,32.861607217287,31.31176697974,29.8053945579176,28.3424079553981,26.9227984263003,25.5466534980568,24.2141454448833],[58.9743781312056,56.8176726892488,54.7044849815256,52.6342144951872,50.6068301670404,48.6226622087339,46.6819735069411,44.7849663148093,42.931886330642,41.1228814775951,39.3579879755407,37.6371732582921,35.9603616069542,34.3274272057227,32.738224623744,31.1926047903765,29.6904404240495,28.2316570171973,26.8162536679065,25.4443262231631,24.11605562706],[58.78444853275,56.6334048754448,54.5256523212309,52.4606090824008,50.4382676482976,48.4589842250472,46.5230455185119,44.6306760819324,42.782143927384,40.9776137879381,39.2171328875328,37.5006787034444,35.8281846668985,34.1995332081028,32.6145866179359,31.0732032001805,29.5752629950274,28.1206989930911,26.7095181752548,25.3418247482764,24.0178083584065],[58.5933478514516,56.4481396674126,54.3459748229761,52.2862903730887,50.2691025783394,48.2947940404179,46.3636761579228,44.4759970201301,42.6320476192619,40.8320137044713,39.0759620909107,37.3638847298259,35.6957243021822,34.0713716788618,32.4906969801803,30.9535659323311,29.4598659000425,28.0095374400675,26.6025954358837,25.239152488193,23.9194069775495],[58.4008384113403,56.2616476995743,54.165237092359,52.1110622609931,50.0991630445449,48.1299480661641,46.2037528976043,44.3208486837996,42.4815494447006,40.6860624648486,38.9344741030457,37.2267945276209,35.5629840653407,33.9429463704525,32.3665594660914,30.8336966507744,29.3442527557191,27.8981759047478,26.4954889134046,25.1363128245461,23.8208547755076],[58.2067728810714,56.073764947594,53.983265434531,51.9347480964098,49.9282758384178,47.9642827700632,46.0431278698561,44.165104275742,42.3305477687815,40.5396859192742,38.7926240279862,37.0893904409218,35.4299626283198,33.8142603150135,32.2421773772335,30.7135988445134,29.2284270290182,27.7866177808041,26.388201950051,25.0333090242691,23.7221549391964],[58.0111620607561,55.8844610379704,53.7999959024637,51.7572576606554,49.7563314685519,47.7976761207456,45.8816731581444,44.0086367219616,42.1789230625209,40.3927784185539,38.6503251929277,36.9516081384163,35.2966208342775,33.6852986858056,32.1175506143318,30.5932761802219,29.112392491894,27.6748668902497,26.2807382975924,24.9301447606449,23.6233110703633],[57.8142543246652,55.6939153616127,53.6155478586641,51.5786586883371,49.5833538343632,47.6301154689796,45.7193465260045,43.8513820294181,42.026596267896,40.2452528037216,38.5074897736896,36.8133661464612,35.1628894661529,33.5560087663987,31.9926466889211,30.4727167118118,28.9961497059,27.5629268454845,26.1731014632564,24.8268234685642,23.5243265093992],[57.6165780428977,55.502565209179,53.4302770619069,51.3992341183135,49.4095609532675,47.4617611386886,45.5562573532664,43.6934059203947,41.8735966217667,40.0971079380885,38.3640929256137,36.6746230936095,35.0287180415311,33.426338424092,31.8674183524721,30.3518830207233,28.8796756089462,27.4507903106953,26.0652937940536,24.7233495503896,23.4252052689579],[57.4189324536597,55.3111103178018,53.2447917271211,51.2195080064137,49.2353994956664,47.292988492953,45.3927153194612,43.5349573428417,41.7201183465651,39.9484893720657,38.2202365419966,36.5354429008352,34.894138729103,33.2962947782447,31.7418550823498,30.2307546206289,28.7629466807041,27.3384363263349,25.9573020146283,24.6197199086332,23.3259505772626],[57.2223672146029,55.1205015061735,53.0599497800896,51.0402508763114,49.0615575842918,47.1244078400434,45.2292570800758,43.3765028398224,41.5665612811615,39.7997347521968,38.0762006477284,36.3960516684249,34.7593280876635,33.1660097437141,31.6160494684306,30.1093910125322,28.6459964535084,27.2258800264458,25.8491299950048,24.5159331981899,23.2265615489492],[57.0281157168881,54.9318841210574,52.876811913243,50.8624420070911,48.888936055508,46.956844256058,45.0666343963974,43.2187227606186,41.4135361682766,39.651387022552,37.9324632649767,36.2568655344597,34.6246425202837,33.0357827942901,31.4902473717737,29.9879880759074,28.528975254547,27.1132316310357,25.7408543217289,24.4120395220635,23.1270688734135],[56.8374933902597,54.7465058251085,52.696558685104,50.6871955967766,48.7185834838816,46.7912813515887,44.9057665190406,43.0624721939029,41.2618341341748,39.5041735082836,37.7896880654564,36.1184858519211,34.4906225713567,32.9060942362307,31.3648700146755,29.8669095499639,28.4121911488771,27.0007459640675,25.6326798111904,24.3081979675787,23.0275912974467],[56.6517711010187,54.5655967092418,52.5203773921776,50.5156545387834,48.5515970178595,46.6287693226017,44.7476555545285,42.908703839473,41.1123572217725,39.3589443838084,37.6486720799903,35.9816553116596,34.3579565376035,32.7775781131768,31.2404963027491,29.7466787866799,28.2961118696843,26.8888351332044,25.52496342251,24.2047113612712,22.9283793035441],[56.4720436436142,54.3902408942408,52.3493372799691,50.3488695630963,48.3890057414471,46.4703128659805,44.5932793330901,42.7583660819679,40.9660219597117,39.216582066386,37.5102613535427,35.847181318613,34.227410963125,32.6509590330197,31.1178079459404,29.627932521839,28.1813274808456,26.7780410276814,25.4181972265961,24.1020206271194,22.8298216962137],[56.2991047426171,54.2212510487807,52.1842640812539,50.1876744309563,48.2316470342645,46.3167491536438,44.4434714078597,42.612285508761,40.8236448656262,39.077890064048,37.3752435378912,35.7158328476513,34.0997333224097,32.5269600859394,30.9975019506461,29.51134005227,28.068476646687,26.6689690469774,25.3129507972685,24.0006566362646,22.7324078294247],[56.1332847432047,54.0590066532705,52.0255793290097,50.0325265569273,48.0800089205328,46.168592232775,44.2987677883904,42.4710163012934,40.6857948189505,38.9434486584649,37.2442071337591,35.5882035672893,33.9755193753009,32.4061760184318,30.8801688662346,29.3974857116661,27.9581355016819,26.5621837001095,25.2097737862546,23.9011508858936,22.6366472968387],[55.9725497582346,53.9015889261958,51.8714716403147,49.8817153931454,47.932476102185,46.0243174246913,44.1577305537938,42.3332039018191,40.5511977264547,38.8120618159747,37.1160320097995,35.4632473685754,33.8537954127553,32.2877040659219,30.7649754180882,29.2856043147135,27.8496069067202,26.4570559613131,25.1081038346622,23.8030064549844,22.5421072469964],[55.8155352718506,53.747742785485,51.7207866632378,49.7341798074083,47.7880742627109,45.8830317476578,44.019543314473,42.1981042520608,40.4191781274946,38.6831192187649,36.9901697820251,35.3404746990329,33.7341277592426,32.1711635064495,30.6515909911121,29.175412387171,27.7426514682863,26.3533888304641,25.0077847322112,23.7061046405464,22.4487034548173],[55.6604682221848,53.595809334671,51.5719769398908,49.5884765034158,47.6454580312484,45.7434824975901,43.8830415076118,42.0646369751977,40.2887362949951,38.5556986231302,36.8657727340663,35.2191095821884,33.6158093914867,32.0559135935207,30.5394384663565,29.0663937771944,27.6368112149659,26.2507795735802,24.9084675059384,23.6101488676001,22.3561884879239],[55.5053174942097,53.4438743976045,51.4232349616194,49.4429033900859,47.5030252000688,45.6041627120376,43.7468094771393,41.9314742927004,40.1586293501405,38.4286393785905,36.7417599986769,35.0981485937087,33.497912077305,31.9410990089853,30.4277331656492,28.9578322225853,27.5314360607466,26.1486418954601,24.8096270763578,23.5146742810611,22.2641568943805],[55.3480152844682,53.2899777842808,51.2726996969468,49.2956903146993,47.3590969652713,45.4634812109443,43.6093405923682,41.7971915198981,40.0275122950141,38.3006741948088,36.6169401733015,34.9764745209251,33.3793911751755,31.8257460418297,30.3155705934964,28.8488907087715,27.4257547818483,26.0462687134329,24.7106187299953,23.4190965230114,22.1720844231069],[55.1868547259193,53.1324533128471,51.1187811724644,49.1453175765163,47.2122177647598,45.3200487565236,43.4693099347832,41.6605264935612,39.8941843926474,38.1706625893368,36.4902320237929,34.8530644275986,33.2592811243017,31.7089456005108,30.2020972036003,28.7387701977558,27.3190217835653,25.9429669104695,24.6108009045812,23.3228246189739,22.0794294876444],[55.0207535704881,52.9702734638981,50.9604554689485,48.9908001171296,47.0614376713324,45.172946242931,43.3258327605434,41.5206283090065,39.7578281435575,38.0378201356751,36.3608839172783,34.7271992229059,33.1368951590605,31.5900430122186,30.0866901295548,28.6268793103751,27.210676775604,25.8382068364451,24.5096743742261,23.2253896930412,21.9857534618128],[54.8495607726605,52.8033159826812,50.797610613962,48.8319879707209,46.9066035679833,45.0220153636098,43.178742628651,41.3773268969492,39.6182702679727,37.9019707196774,36.2287172939854,34.5986982768159,33.0120509056252,31.4688544646404,29.9691644492181,28.51303229171,27.1005333670851,25.7318016015832,24.407051895537,23.1266045923315,21.8908700104095],[54.6742423568891,52.6325441344294,50.6311935397038,48.6697953014816,46.7485507797099,44.8680467622165,43.0287844817367,41.2313194747173,39.4761651713645,37.7637268293159,36.0943035471427,34.4680926128249,32.8852397032337,31.3458322991508,29.8499341201073,28.397605323186,26.9889305686163,25.6240535954266,24.3031996856854,23.0266998912923,21.7949750482466],[54.4968807162531,52.4600702264863,50.4632726898927,48.506234591486,46.5892208669612,44.7128662866505,42.8777019383047,41.0842669870891,39.3330892221098,37.6245851874392,35.9590608015607,34.3367226685796,32.7577251049065,31.2221639299567,29.7301111697296,28.281635772669,26.8768317999259,25.5158529890261,24.1989353162448,22.9264210960554,21.6987426477595],[54.3202018255878,52.2885645239922,50.2965213251742,48.3439115425752,46.4311406751149,44.5589074947718,42.7277907255392,40.9383601341044,39.1911273085266,37.4865226084088,35.8248625351093,34.2063594806792,32.6311765544534,31.0994180107923,29.6111642935921,28.1664932732185,26.7655085809879,25.4083741689242,24.0953370537045,22.8267513522488,21.6030617583218],[54.1477592373776,52.1215179249806,50.1343575949244,48.1862281110097,46.2776283342113,44.4093938393084,42.5821652486286,40.796559722041,39.0531188901401,37.3522558027398,35.6942997289933,34.0794725191507,32.5079423022268,30.9798218442411,29.495200070234,28.0541639161618,26.6568267822563,25.3033630816081,23.9940312409731,22.7291976537618,21.50932020894],[53.9827983728153,51.9621146094117,49.9799188401619,48.0362645524313,46.1317610125597,44.2673335595167,42.4437536683365,40.6616987557826,38.9217564818003,37.2243685214253,35.5698450558433,33.9584194944431,32.3902687862063,30.8655102712902,29.3842414736739,27.9465585760982,26.552584977566,25.2025058357053,23.896591364284,22.6352207479971,21.4188657653688],[53.8276519343815,51.8125870793848,49.8354165647203,47.8962241075999,45.9957227864499,44.1349432469844,42.3147400401166,40.5359171298908,38.7991198811488,37.1048340356483,35.4533968457109,33.8450205359684,32.2798930546023,30.7581404366331,29.2798647655375,27.8451716803929,26.4541948990494,25.1071306618492,23.8042613408818,22.5459793673458,21.3327710959451],[53.6830677849347,51.6736157022869,49.7014972613083,47.7667933326109,45.8702511104123,44.0129995290115,42.1959899271188,40.4201043640078,38.6861104895505,36.9945489355925,35.3457993297637,33.7400995112005,32.1776145664862,30.6584816701919,29.1828119462356,27.7507163051956,26.3623390910218,25.0178879844222,23.7176578853833,22.4620548562776,21.2515803059218],[53.5477048129638,51.5438240951695,49.5768003627949,47.6466569955523,45.7541449227407,43.9004246087367,42.0865361317713,40.3134523969837,38.5820141002656,36.8928805765218,35.2464842363745,33.6431039695128,32.0829297925864,30.5660748872329,29.0926620802249,27.6628124266949,26.2766763962201,24.9344733728369,23.6365110273143,22.3832093024006,21.1750849282022],[53.4178470609632,51.4195910591766,49.4577586539609,47.5323476770148,45.6440621770647,43.7940667286809,41.9834248521873,40.2131918869412,38.4842940068508,36.7974590076672,35.1532361614002,33.5519557756019,31.9938485430808,30.4790526967638,29.0076661911907,27.5798229839389,26.1956848109937,24.8554776994239,23.5595221392362,22.3082518443756,21.1021987220206],[53.2877604382578,51.2953435348598,49.3389632177087,47.4185792841982,45.534881208395,43.6889915962674,41.881971741289,40.1148952532535,38.3887654044129,36.7043908783006,35.0623864715296,33.4631990808338,31.9071106999743,30.3943007729019,28.9248929110892,27.498995799162,26.1167851016316,24.7784986764251,23.4844639490802,22.2351279061753,21.0310369082007],[53.1505156365768,51.1643320701427,49.2138622779473,47.2989994673372,45.4204085422565,43.5792037490925,41.7764011820193,40.013068623817,38.2902227168551,36.6087446664507,34.9693274705967,33.3724820389549,31.8186086318218,30.3079389541733,28.8406389329535,27.4168442227866,26.0367044993627,24.7004718323826,23.4084855790802,22.1611989897672,20.959171498701],[52.9991094646775,51.0197320372618,49.0758058267397,47.167150154067,45.2943803918537,43.4585950920131,41.6607993710823,39.902014562194,38.1832474584172,36.5053875254261,34.8691974444179,33.2752651468657,31.7240552767941,30.2159211129324,28.7510824801078,27.3297191630231,25.9520091101603,24.6181768750329,23.3285756435729,22.0836695585398,20.884022603679],[52.8283431688546,50.8562006401374,48.9195670944429,47.0179195706652,45.1518190115102,43.322326719689,41.5304306337252,39.7771405863569,38.0634139140604,36.3901249043689,34.758040089655,33.1678154623438,31.6199934825151,30.1149934019179,28.6531611403888,27.234732777832,25.859932141919,24.5290129140822,23.2422986324279,22.0002655097873,20.8034861899894],[52.6357389642595,50.6715353682453,48.7426749618078,46.8488469470952,44.9902770813311,43.1679869309525,41.382927163125,39.6360904353539,37.928419914479,36.2607345031808,34.6337798994378,33.048211686228,31.5046405239283,30.0035653486365,28.5454005037416,27.1305138077773,25.7591877850161,24.4317231742392,23.1484731225215,21.9098807790341,20.7165278130222]]; //age 16 to 75 reg age 55 to 75
const life_expectancy = {
    Male: [83,83,83,83,83,83,83,83,83,83,83,84,84,84,84,84,84,84,84,84,84,84,85,85,85,85,85,85,85,85,85,85,85,85,85,85,85,85,86,86,86,86,86,86,86,86,86,86,86,86,86,87,87,87,87,87,87,88,88,88], // 16 to 75
    Female: [87,87,87,87,86,87,87,87,87,87,87,87,87,87,87,87,87,87,87,87,87,87,88,88,88,88,88,88,88,88,88,88,88,88,88,88,88,88,88,88,88,88,88,88,88,88,88,88,88,88,88,89,89,89,89,89,89,89,89,89]
 }; //55 to 75


class RetirementPension {
    adjustedPreNRApension: number;
    adjustedPostNRApension: number;
    adjustedPreNRALumpSum: number;
    adjustedPostNRALumpSum: number;
    adjustedExtraLumpSum: number;
    totalPension: number;
    totalLumpSum: number;
    totalAdditionalLumpSum: number;
}

class CAREBenefit {
    pensionPreNRA: number;
    pensionPreNRAnoInc: number;
    pensionableSalary: number;
    pensionPostNRA: number;
    pensionPostNRAnoInc: number;
    accrual: number;
    nra: number;
    status: string;
    ageDeferred: number;
    retirementPensionValues: RetirementPension;
    retirementAge: number;

    constructor(pensionPreNRA: number, noIncPensionPreNRA: number, pensionableSalaryFTE: number, accrual: number, nra: number) {
        this.pensionPreNRA = pensionPreNRA - noIncPensionPreNRA;
        this.pensionPreNRAnoInc = noIncPensionPreNRA;
        this.pensionableSalary = pensionableSalaryFTE;
        this.pensionPostNRA = 0;
        this.pensionPostNRAnoInc = 0;
        this.accrual = accrual;
        this.nra = nra;
        this.status = 'Active';
    }

    setDeferred(age: number) {
        this.status = 'Deferred';
        this.ageDeferred = age;

        this.pensionPreNRA += this.pensionPreNRAnoInc;
        this.pensionPreNRAnoInc = 0;

        this.pensionPostNRA += this.pensionPostNRAnoInc;
        this.pensionPostNRAnoInc = 0;
    }

    setRetired(age: number) {
        this.retirementAge = Math.round(age);
        this.retirementPensionValues =
            calculateRetirement_care_npaSPA(
                this.getPensionPreNRA(), this.getPensionPostNRA(),
                this.retirementAge, this.nra, this.status == 'Active');
    }

    getPensionPreNRA(): number {
        return this.pensionPreNRA + this.pensionPreNRAnoInc;
    }

    getPensionPostNRA(): number {
        return this.pensionPostNRA + this.pensionPostNRAnoInc;
    }

    updatePensionableSalary(salaryFTE: number) {
        if (this.status == 'Active') {
            this.pensionableSalary = Math.max(this.pensionableSalary, salaryFTE);
        }
    }

    rollforwardBenefit(increaseActive: number, increaseDeferred: number) {
        if (this.status == 'Active') {
            this.pensionPreNRA *= (1 + increaseActive);
            this.pensionPostNRA *= (1 + increaseActive);
        } else {
            this.pensionPreNRA *= (1 + increaseDeferred);
            this.pensionPostNRA *= (1 + increaseDeferred);
        }
        this.pensionPreNRA += this.pensionPreNRAnoInc;
        this.pensionPreNRAnoInc = 0;

        this.pensionPostNRA += this.pensionPostNRAnoInc;
        this.pensionPostNRAnoInc = 0;
    }

    addMonthAccrual(serviceProportion: number, age: number) {

        if (age <= this.nra) {
            this.pensionPreNRAnoInc += serviceProportion * this.pensionableSalary / this.accrual / 12;
        } else {
            this.pensionPostNRAnoInc += serviceProportion * this.pensionableSalary / this.accrual / 12;
        }

    }
}

class FSBenefit {
    servicePreNRA: number;
    pensionableSalary: number;
    servicePostNRA: number;
    accrual: number;
    nra: number;
    status: string;
    ageDeferred: number;
    retirementPensionValues: RetirementPension;
    retirementAge: number;
    salaryThis: number;
    salaryLast: number;

    constructor(pensionPreNRA: number, pensionableSalaryFTE: number, accrual: number, nra: number) {
        this.servicePreNRA = pensionPreNRA > 0 ? pensionPreNRA / pensionableSalaryFTE * accrual : 0;
        this.pensionableSalary = pensionableSalaryFTE;
        this.salaryThis = pensionableSalaryFTE;
        this.salaryLast = pensionableSalaryFTE;
        this.servicePostNRA = 0;
        this.accrual = accrual;
        this.nra = nra;
        this.status = 'Active';
    }

    setDeferred(age: number) {
        this.status = 'Deferred';
        this.ageDeferred = age;
    }

    setRetired(age: number) {
        this.retirementAge = Math.round(age);
        if (this.accrual == 80) {
            this.retirementPensionValues =
                calculateRetirement_80ths_npa60(
                    this.getPensionPreNRA(this.retirementAge ) + this.getPensionPostNRA(this.retirementAge ),
                    this.getLumpSumPreNRA(this.retirementAge ) + this.getLumpSumPostNRA(this.retirementAge ),
                    this.retirementAge , this.status == 'Active');
        } else {
            this.retirementPensionValues =
                calculateRetirement_60ths_npa65(
                    this.getPensionPreNRA(this.retirementAge ), this.getPensionPostNRA(this.retirementAge ),
                    this.retirementAge );
        }
    }

    getPensionPreNRA(age: number): number {
        return this.servicePreNRA * this.pensionableSalary / this.accrual * (this.status == 'Deferred' ? Math.pow(assumptions.inflation + 1, age - this.ageDeferred) : 1);
    }

    getPensionPostNRA(age: number): number {
        return this.servicePostNRA * this.pensionableSalary / this.accrual * (this.status == 'Deferred' ? Math.pow(assumptions.inflation + 1, age - this.ageDeferred) : 1);
    }

    getLumpSumPreNRA(age: number): number {
        if (this.accrual == 80) {
            return this.getPensionPreNRA(age) * 3;
        } else {
            return 0;
        }
    }

    getLumpSumPostNRA(age: number): number {
        if (this.accrual == 80) {
            return this.getPensionPostNRA(age) * 3;
        } else {
            return 0;
        }
    }

    updatePensionableSalary(salaryFTE: number) {

        if (this.status == 'Active') {
            //this.pensionableSalary = Math.max(this.pensionableSalary, salaryFTE);
            this.salaryLast = this.salaryThis;
            this.pensionableSalary = this.salaryLast;
            this.salaryThis = Math.max(this.pensionableSalary, salaryFTE);
        }
    }

    addMonthAccrual(serviceProportion: number, age: number) {

        if (age <= this.nra) {
            this.servicePreNRA += serviceProportion / 12;
        } else {
            this.servicePostNRA += serviceProportion / 12;
        }

        if (this.status == 'Active') {
            this.pensionableSalary -= this.salaryLast / 12;
            this.pensionableSalary += this.salaryThis / 12;
        }

    }
}

const calculateRetirement_80ths_npa60 = function (pension: number, lumpsum: number, retirementAge: number, active: boolean): RetirementPension {
    const result = new RetirementPension();

    if (retirementAge <= 60) {
        // apply early retirement factors
        /*
        Pre-2007 entrants
        Active or deferred members below age 60 at retirement
        2.5 Early retirement pension =
        Main scheme pension x Factor ER1
        + Additional Pension (option exercised on or before 22 June 2010) x Factor ER2
        + Additional Pension (option exercised after 22 June 2010) x Factor ER3
        - pension debit(s) pension x Factor ER1
        2.6 Early retirement lump sum =
        Main scheme lump sum x Factor ER1
        - pension debit(s) lump sum x Factor ER1
        */
        const factor = erf_80ths_npa60[Math.min(60 - retirementAge, 5)];
        result.adjustedPreNRApension = pension * factor;
        result.adjustedPostNRApension = 0;
        result.adjustedPreNRALumpSum = lumpsum * factor;
        result.adjustedPostNRALumpSum = 0;
        result.adjustedExtraLumpSum = 0;
    } else {
        /*
        Pre-2007 entrants (NPA 60 members) retiring after age 60
        2.3 Late retirement pension =
        NPA 60 main scheme pension
        + Additional Pension
        - Pension sharing on divorce pension debit(s)
        - Annual allowance pension debit(s) x Factor LR3
        2.4 Late retirement lump sum =
        NPA 60 scheme lump sum
        - Pension sharing on divorce lump sum debit(s)
        - Annual allowance lump sum debit(s) x Factor LR3
        */
        const factor = 1;
        result.adjustedPreNRApension = pension * factor;
        result.adjustedPostNRApension = 0;
        result.adjustedPreNRALumpSum = lumpsum * factor;
        result.adjustedPostNRALumpSum = 0;
        //found no evidence of this?
        // result.adjustedExtraLumpSum = active ? 0 : (result.adjustedPreNRApension + result.adjustedPostNRApension) * (retirementAge - 60);
    }

    result.totalPension = result.adjustedPreNRApension + result.adjustedPostNRApension;
    result.totalLumpSum = result.adjustedPreNRALumpSum + result.adjustedPostNRALumpSum;
    result.totalAdditionalLumpSum = result.adjustedExtraLumpSum;

    return result;
}

const calculateRetirement_60ths_npa65 = function (PreNPApension: number, postNPApension: number, retirementAge: number): RetirementPension {
    const result = new RetirementPension();

    if (retirementAge <= 65) {
        // apply early retirement factors
        /*
        2007 or later entrants
        Early retirement of active or deferred members
        2.10 Early retirement pension =
        Main scheme pension x Factor ER4
        + Additional Pension (option exercised on or before 22 June 2010) x Factor ER5
        + Additional Pension (option exercised after 22 June 2010) x Factor ER6
        - pension debit(s) pension x Factor ER4
        */
        const factor = erf_60ths_npa65[Math.min(65 - retirementAge, 10)];
        result.adjustedPreNRApension = PreNPApension * factor;
        result.adjustedPostNRApension = postNPApension * factor;
        result.adjustedPreNRALumpSum = 0;
        result.adjustedPostNRALumpSum = 0;
        result.adjustedExtraLumpSum = 0;
    } else {
        /*
        2007 or later entrants (NPA 65 members) retiring after age 65
        2.8 Late retirement pension =
        NPA 65 main scheme pension calculated based on service to 65 x Factor LR1
        + NPA 65 main scheme pension for service after age 65
        + Additional Pension
        - Pension sharing on divorce pension debit(s) x Factor LR2
        - Annual allowance pension debit(s) x Factor LR2
        */
        const factor = lrf_60ths_npa65_preNPAservice[Math.min(retirementAge - 65, 10)];
        result.adjustedPreNRApension = PreNPApension * factor;
        result.adjustedPostNRApension = postNPApension;
        result.adjustedPreNRALumpSum = 0;
        result.adjustedPostNRALumpSum = 0;
        result.adjustedExtraLumpSum = 0;
    }

    result.totalPension = result.adjustedPreNRApension + result.adjustedPostNRApension;
    result.totalLumpSum = result.adjustedPreNRALumpSum + result.adjustedPostNRALumpSum;
    result.totalAdditionalLumpSum = result.adjustedExtraLumpSum;

    return result;
}

const calculateRetirement_care_npaSPA = function (PreNPApension: number, postNPApension: number, retirementAge: number, npa: number, active: boolean): RetirementPension {
    const result = new RetirementPension();

    if (retirementAge <= npa) {
        // apply early retirement factors
        /*
        Active members
        4.8 Early retirement pension =
        Full retirement earned pension x standard reduction x Factor ER7
        + Additional Pension x Factor ER8
        - pension debit(s) pension x Factor ER8

        Deferred members – pension not subject to a buy-out election
        4.10 Early retirement pension =
        Full retirement earned pension x Factor ER8
        + Additional Pension x Factor ER8
        - pension debit(s) pension x Factor ER8
        */

        const factor = active ? erf_60ths_npa65[Math.max(Math.min(65 - retirementAge, 10), 0)] * Math.pow(1 - 0.03, npa - Math.max(65, retirementAge)) : erf_care_deferred[Math.min(npa - retirementAge, 13)];
        result.adjustedPreNRApension = PreNPApension * factor;
        result.adjustedPostNRApension = postNPApension * factor;
        result.adjustedPreNRALumpSum = 0;
        result.adjustedPostNRALumpSum = 0;
        result.adjustedExtraLumpSum = 0;
    } else {
        /*
        If a member retires after Normal Pension Age (NPA)2 a late retirement uplift may
        need to be applied to the member’s pension in accordance with Regulation 87. An
        uplift will only need to be applied if the member was in pensionable service for part or
        all of the period between NPA and retirement. No uplift is applied to any Additional
        Pension or for any retirements where the member has no pensionable service
        between NPA and retirement.
        */
        const factor = postNPApension > 0 ? lrf_care_active[Math.min(retirementAge - npa, 10)] : 1;
        result.adjustedPreNRApension = PreNPApension * factor;
        result.adjustedPostNRApension = postNPApension;
        result.adjustedPreNRALumpSum = 0;
        result.adjustedPostNRALumpSum = 0;
        // not sure?
        //result.adjustedExtraLumpSum = postNPApension <= 0 ? (result.adjustedPreNRApension + result.adjustedPostNRApension) * (retirementAge - npa) : 0;
    }

    result.totalPension = result.adjustedPreNRApension + result.adjustedPostNRApension;
    result.totalLumpSum = result.adjustedPreNRALumpSum + result.adjustedPostNRALumpSum;
    result.totalAdditionalLumpSum = result.adjustedExtraLumpSum;

    return result;
}

const getTPScontribution = function (salary: number): number {
    if (salary < 28309.99) return 0.074;
    if (salary < 38108.99) return 0.086;
    if (salary < 45185.99) return 0.096;
    if (salary < 59885.99) return 0.102;
    if (salary < 81661.99) return 0.113;
    return 0.117;
}

const getGDSTContribution = function (cont: number): number {
    switch (cont) {
        case 2: return 0.08;
        case 5: return 0.12;
        case 8: return 0.16;
        default: return 0.18;
    }
}

const getGDSTSuppliment = function (cont: number): number {
    switch (cont) {
        case 2: return 0.1;
        case 5: return 0.06;
        case 8: return 0.02;
        default: return 0;
    }
}

const getInvestmentReturn = function (val: string): number {
    switch (val) {
        case 'Low': return 0.0;
        case 'Medium': return 0.02;
        case 'High': return 0.04;
        default: return 0.02;
    }
}

const getAnnuityFactor = function (retAge: number, age: number): number {
    const ageUse = Math.max(Math.min(Math.floor(age), 75), 16) - 16;
    return annuity_Factors[ageUse][retAge - 55];
}

const getLifeExpectancy = function (age: number, gender: string): number {
    return life_expectancy[gender][age - 16];
}

const caclculateTax = function (amount): number {
    amount *= 12;
    const pa = taxCalcParams.personalAllowance - Math.min(Math.max(amount - taxCalcParams.personalAllowanceReducedFrom, 0) * taxCalcParams.personalAllowanceReducedRate, taxCalcParams.personalAllowance);

    const basicRateTax = Math.max(Math.min(amount - pa, taxCalcParams.basicRateLimit), 0) * taxCalcParams.basicRate;
    const higherRateTax = Math.max(Math.min(amount - pa - taxCalcParams.basicRateLimit, taxCalcParams.higherRateLimit - taxCalcParams.basicRateLimit), 0) * taxCalcParams.higherRate;
    const additionalRateTax = Math.max(amount - pa - taxCalcParams.higherRateLimit, 0) * taxCalcParams.additionalRate;

    return basicRateTax + higherRateTax + additionalRateTax;
};

const calculateNI = function (amount): number {
    // let
    amount *= 12;
    const bandNI = Math.max(Math.min(amount - niCalcParams.threshold, niCalcParams.upperBand - niCalcParams.threshold), 0) * niCalcParams.bandRate;
    const aboveBandNI = Math.max(amount - niCalcParams.upperBand, 0) * niCalcParams.higherRate;
    return bandNI + aboveBandNI;
};

const calculateAgeInMonthsOfUnprotection = function (age_in_months_April_2012: number, NPA: number): number {

    if (NPA*12 - age_in_months_April_2012 < 120) return 100*12;
    return NPA*12 - Math.min(Math.max((NPA - 10)*12 - age_in_months_April_2012, 0),42) * 2;
}

const get_spd = function (dob: Moment, gender: string) {
    if (gender === 'Female') {
        if (dob.isSameOrBefore(moment('05/04/1950', 'DD/MM/YYYY'))) return dob.clone().add(60, 'years');

        if (dob.isSameOrBefore(moment('05/04/1953', 'DD/MM/YYYY'))) {
            let m = -moment('06/04/1950', 'DD/MM/YYYY').diff(dob, 'months', false);
            return moment('06/04/2010', 'DD/MM/YYYY').add(m*2 + 1, 'months');
        } else if (dob.isSameOrBefore(moment('05/12/1953', 'DD/MM/YYYY'))) {
            let m = -moment('06/04/1953', 'DD/MM/YYYY').diff(dob, 'months', false);
            return moment('06/04/2016', 'DD/MM/YYYY').add(m*4 + 3, 'months');
        } else if (dob.isSameOrBefore(moment('05/10/1954', 'DD/MM/YYYY'))) {
            let m = -moment('06/12/1953', 'DD/MM/YYYY').diff(dob, 'months', false);
            return moment('06/12/2018', 'DD/MM/YYYY').add(m*2 + 3, 'months');
        } else if (dob.isSameOrBefore(moment('05/04/1960', 'DD/MM/YYYY'))) {
            return dob.clone().add(66, 'years');
        } else if (dob.isSameOrBefore(moment('05/03/1961', 'DD/MM/YYYY'))) {
            let m = -moment('06/04/1960', 'DD/MM/YYYY').diff(dob, 'months', false);
            return dob.clone().add(66, 'years').add(m + 1, 'months');
        } else if (dob.isSameOrBefore(moment('05/04/1977', 'DD/MM/YYYY'))) {
            return dob.clone().add(67, 'years');
        } else if (dob.isSameOrBefore(moment('05/04/1978', 'DD/MM/YYYY'))) {
            let m = -moment('06/04/1977', 'DD/MM/YYYY').diff(dob, 'months', false);
            return dob.clone().add(67, 'years').add(m + 1, 'months');
        } else {
            return dob.clone().add(68, 'years');
        }
    } else {
        if (dob.isSameOrBefore(moment('05/12/1953', 'DD/MM/YYYY'))) return dob.clone().add(65, 'years');

        if (dob.isSameOrBefore(moment('05/10/1954', 'DD/MM/YYYY'))) {
            let m = -moment('06/12/1953', 'DD/MM/YYYY').diff(dob, 'months', false);
            return moment('06/12/2018', 'DD/MM/YYYY').add(m*2 + 3, 'months');
        } else if (dob.isSameOrBefore(moment('05/04/1960', 'DD/MM/YYYY'))) {
            return dob.clone().add(66, 'years');
        } else if (dob.isSameOrBefore(moment('05/03/1961', 'DD/MM/YYYY'))) {
            let m = -moment('06/04/1960', 'DD/MM/YYYY').diff(dob, 'months', false);
            return dob.clone().add(66, 'years').add(m + 1, 'months');
        } else if (dob.isSameOrBefore(moment('05/04/1977', 'DD/MM/YYYY'))) {
            return dob.clone().add(67, 'years');
        } else if (dob.isSameOrBefore(moment('05/04/1978', 'DD/MM/YYYY'))) {
            let m = -moment('06/04/1977', 'DD/MM/YYYY').diff(dob, 'months', false);
            return dob.clone().add(67, 'years').add(m + 1, 'months');
        } else {
            return dob.clone().add(68, 'years');
        }
    }
}

const calculateConstraints = function (userInputs: UserInputs, retirementOptions: UserRetirementOptions, accumulationInputs: UserAccumulationOptions, accumulationVariables: UserAccumulationIllustration): IllustrationOutput {

    const _dob = moment(userInputs.dateOfBirth, 'DD/MM/YYYY');

    spd = get_spd(_dob, userInputs.gender);
    dob = _dob;

    const endAge = 100;

    const doc = moment();
    let age_m = moment(doc).diff(dob, 'months', false);
    const age_now = age_m / 12;
    let spa_m = moment(spd).diff(doc, 'months', false);
    let spa = moment(spd).diff(dob, 'years', false);

    let nra = 0;
    if (userInputs.accuredPension80 == Math.max(userInputs.accuredPension80, userInputs.accuredPension60, userInputs.accruedCARE)) {
        nra = 60;
    } else if (userInputs.accuredPension60 == Math.max(userInputs.accuredPension80, userInputs.accuredPension60, userInputs.accruedCARE)) {
        nra = 65;
    } else {
        nra = Math.floor(moment(spd).diff(dob, 'years', false));
    }

    const output = new IllustrationOutput(age_m / 12, nra, getLifeExpectancy(Math.floor(age_m / 12), userInputs.gender));

    return output;
}

const calculateBenefits = function (userInputs: UserInputs, retirementOptions: UserRetirementOptions, accumulationInputs: UserAccumulationOptions, accumulationVariables: UserAccumulationIllustration): IllustrationOutput {

    const _dob = moment(userInputs.dateOfBirth, 'DD/MM/YYYY');

    spd = get_spd(_dob, userInputs.gender);
    dob = _dob;

    const endAge = 100;

    const doc = moment();
    let age_m = moment(doc).diff(dob, 'months', false);
    const age_now = age_m / 12;
    let spa_m = moment(spd).diff(doc, 'months', false);
    let spa = moment(spd).diff(dob, 'years', false);

    let nra = 0;
    if (userInputs.accuredPension80 == Math.max(userInputs.accuredPension80, userInputs.accuredPension60, userInputs.accruedCARE)) {
        nra = 60;
    } else if (userInputs.accuredPension60 == Math.max(userInputs.accuredPension80, userInputs.accuredPension60, userInputs.accruedCARE)) {
        nra = 65;
    } else {
        nra = Math.floor(moment(spd).diff(dob, 'years', false));
    }

    const output = new IllustrationOutput(age_m / 12, nra, getLifeExpectancy(Math.floor(age_m / 12), userInputs.gender));

    const monthlyInflation = Math.pow(1 + assumptions.inflation, 1 / 12) - 1;

    const age_transitional = moment(transitionalDateComparitor).diff(dob, 'months', false);
    const months_before_transition_NPA_60 = calculateAgeInMonthsOfUnprotection(age_transitional, 60);
    const months_before_transition_NPA_65 = calculateAgeInMonthsOfUnprotection(age_transitional, 65);
    const retAge = retirementOptions.retirementAge;
    const retAge_m = retirementOptions.retirementAge * 12 - age_m;
    const retirement_months = (100 - retirementOptions.retirementAge) * 12;

    const monthsToImplementation = moment(prososedDateOfImplementation).diff(doc, 'months', false);

    const _dateOfPensionData = moment(userInputs.dateOfPensionData, 'DD/MM/YYYY');

    let _previousCareIncDate = _dateOfPensionData.clone().add(1, 'days');;

    while (_previousCareIncDate.month() !== 3 ||  _previousCareIncDate.date() !== 1) {
        if (_previousCareIncDate.month() === _dateOfPensionData.month() && _previousCareIncDate.date() !== 1) {
            _previousCareIncDate = _previousCareIncDate.add(-1, 'days');
        } else {
            _previousCareIncDate = _previousCareIncDate.add(-1, 'months');
        }
    }

    _previousCareIncDate = _previousCareIncDate.add(-1, 'days');

    const monthsFromCareToDOD = moment(_dateOfPensionData).diff(_previousCareIncDate, 'months', false);

    const monthsFromDataToDOC = moment(doc).diff(_dateOfPensionData, 'months', false);

    const totalProjection = monthsFromDataToDOC + retAge_m + retirement_months + 1;

    const termToImplementation = monthsFromDataToDOC + monthsToImplementation + 1;

    const termToStatePensionAge = monthsFromDataToDOC + spa_m + 1;

    const termToRetirement = monthsFromDataToDOC + retAge_m + 1;

    let datePass = moment(doc).add(-monthsFromDataToDOC, 'months');

    let curAccrual = userInputs.currentPartTimeProportion / 100;

    output.inServiceImpact.memeberContributionPC = accumulationInputs.memberDCcontribution;

    let pen80 = new FSBenefit(userInputs.accuredPension80, userInputs.averageSalary80, 80, 60);
    let pen80Active = new FSBenefit(userInputs.accuredPension80, userInputs.averageSalary80, 80, 60);


    let pen60 = new FSBenefit(userInputs.accuredPension60, userInputs.averageSalary60, 60, 65);
    let pen60Active = new FSBenefit(userInputs.accuredPension60, userInputs.averageSalary60, 60, 65);

    let propPreviousYearCare = Math.min(monthsFromCareToDOD / 12 / 57 * curAccrual * userInputs.currentFullTimeSalary, userInputs.accruedCARE);

    let care = new CAREBenefit(userInputs.accruedCARE, propPreviousYearCare, userInputs.currentFullTimeSalary, 57, Math.floor(moment(spd).diff(dob, 'years', false)))
    let careActive = new CAREBenefit(userInputs.accruedCARE, propPreviousYearCare, userInputs.currentFullTimeSalary, 57, Math.floor(moment(spd).diff(dob, 'years', false)))

    let curSal = userInputs.currentFullTimeSalary;
    let curSalTPS = userInputs.currentFullTimeSalary;
    let dcPot = 0;
    let retirementTarget = Math.max(retirementOptions.retirementTarget,0);
    let annuityIncome = 0;
    let inf = 1;
    let retirementMonthCount = 1;
    let retirementYear = 0;

    let preLumpSumTotal = 0;
    let postLumpSumTotal = 0;
    let preLumpSumTotalIncTPS = 0;
    let postLumpSumTotalIncTPS = 0;
    let monthlyStatePension = 9339 / 12;

    let active = true;

    for (let m = 1; m < totalProjection; m++) {

        const age_M =  moment(datePass).diff(dob, 'months', false);
        const age = age_M / 12;

        if (datePass.month() === 3) {
            //increase in april
            const increase = assumptions.inflation;
            monthlyStatePension *= (1 + increase);
            postLumpSumTotal *= (1 + increase);
            postLumpSumTotalIncTPS *= (1 + increase);
            retirementTarget *= (1 + increase);
        }

        //roll forward salaries

        if (m < termToRetirement) {

            if (datePass.month() === 3) {
                //increase in april
                let increaseActive = assumptions.inflation + assumptions.careExcessIncreases;
                const incraseDeferred = assumptions.inflation;

                if (datePass.year() === 2022) {
                    increaseActive = piro2022;
                }

                care.rollforwardBenefit(increaseActive, incraseDeferred);
                careActive.rollforwardBenefit(increaseActive, incraseDeferred);
            }

            //salary increases
            if (datePass.month() === 8) {
                //increase in september


                if (datePass > doc) {

                    if (datePass.year() === 2022) {

                        curSal *= (1 + assumptions.salInc2022GDST + assumptions.inflation + accumulationVariables.salaryGrowth / 100);
                        curSalTPS *= (1 + assumptions.salInc2022TPS + assumptions.inflation + accumulationVariables.salaryGrowth / 100);
                    } else if (datePass.year() === 2023) {
                        curSal *= (1 + assumptions.salInc2023GDST + assumptions.inflation + accumulationVariables.salaryGrowth / 100);
                        curSalTPS *= (1 + assumptions.salInc2023TPS + assumptions.inflation + accumulationVariables.salaryGrowth / 100);
                    } else {
                        const increase = assumptions.inflation + accumulationVariables.salaryGrowth / 100;
                        curSal *= (1 + increase);
                        curSalTPS *= (1 + increase);
                    }

                }

                pen60.updatePensionableSalary(curSal);
                pen60Active.updatePensionableSalary(curSalTPS);
                pen80.updatePensionableSalary(curSal);
                pen80Active.updatePensionableSalary(curSalTPS);
                care.updatePensionableSalary(curSal);
                careActive.updatePensionableSalary(curSalTPS);
            }

            let penCareAccrual = curAccrual;
            let pen80Accrual = 0;
            let pen60Accrual = 0;

            if (age_M < months_before_transition_NPA_60 && pen80.getPensionPreNRA(age) > 0 && pen60.getPensionPreNRA(age) === 0 && care.getPensionPreNRA() === 0) {
                pen80Accrual = curAccrual;
                penCareAccrual = 0;
            } else if (age_M < months_before_transition_NPA_65 && pen60.getPensionPreNRA(age) > 0 && care.getPensionPreNRA() === 0) {
                pen60Accrual = curAccrual;
                penCareAccrual = 0;
            }

            pen60Active.addMonthAccrual(pen60Accrual, age);
            pen80Active.addMonthAccrual(pen80Accrual, age);
            careActive.addMonthAccrual(penCareAccrual, age);

            if (m < termToImplementation) {
                //project to doc (assume current PT ratio and salary)

                pen60.addMonthAccrual(pen60Accrual, age);
                pen80.addMonthAccrual(pen80Accrual, age);
                care.addMonthAccrual(penCareAccrual, age);

            } else {

                active = false;

                if (pen80.status === 'Active') {
                    pen80.setDeferred(age);
                    pen60.setDeferred(age);
                    care.setDeferred(age);
                }

                let dcSalaryContribution = curSal * accumulationInputs.memberDCcontribution / 100 / 12 * curAccrual;
                let totalSalaryGDSTContribution = curSal * getGDSTContribution(accumulationInputs.memberDCcontribution) / 12 * curAccrual;
                let totalGDSTsuppliment = curSal * getGDSTSuppliment(accumulationInputs.memberDCcontribution) / 12 * curAccrual;

                if (m === termToImplementation) {
                    // record salary etc
                    let foundContribution = true;
                    let rollback = true;

                    output.inServiceImpact.illustratedSalary = curSal / 12 / inf * curAccrual;
                    output.inServiceImpact.illustratedSalaryTPS = curSalTPS / 12 / inf * curAccrual;
                    output.inServiceImpact.memberContribution = dcSalaryContribution / inf;
                    output.inServiceImpact.gdstContribution = totalSalaryGDSTContribution / inf;
                    output.inServiceImpact.illustratedCashSuppliment = totalGDSTsuppliment / inf;
                    output.inServiceImpact.memeberContributionPC = accumulationInputs.memberDCcontribution;

                    if (accumulationInputs.matchTakehomeSalary && accumulationInputs.rewardOption === 'Pension Max') {
                        foundContribution = false;
                        rollback = false;
                        dcSalaryContribution = curSal * 10 / 100 / 12 * curAccrual;
                        output.inServiceImpact.memeberContributionPC = 10;
                        totalSalaryGDSTContribution = curSal * getGDSTContribution(output.inServiceImpact.memeberContributionPC) / 12 * curAccrual;
                        totalGDSTsuppliment = curSal * getGDSTSuppliment(output.inServiceImpact.memeberContributionPC) / 12 * curAccrual;
                        output.inServiceImpact.illustratedSalary = curSal / 12 / inf * curAccrual;
                        output.inServiceImpact.illustratedSalaryTPS = curSalTPS / 12 / inf * curAccrual;
                        output.inServiceImpact.memberContribution = dcSalaryContribution / inf;
                        output.inServiceImpact.gdstContribution = totalSalaryGDSTContribution / inf;
                        output.inServiceImpact.illustratedCashSuppliment = totalGDSTsuppliment / inf;
                    }

                    do {
                        //impact on takehome //student loan
                        let salaryTaxable = (output.inServiceImpact.illustratedSalary - output.inServiceImpact.memberContribution + output.inServiceImpact.illustratedCashSuppliment);
                        output.inServiceImpact.approxTax = (caclculateTax(salaryTaxable) + calculateNI(salaryTaxable)) / 12;
                        output.inServiceImpact.approxTakehomePay = salaryTaxable - output.inServiceImpact.approxTax;

                        const tpsContribution = getTPScontribution(curSalTPS / inf);
                        output.inServiceImpact.memberContributionTPS = output.inServiceImpact.illustratedSalaryTPS * tpsContribution;
                        let salaryTaxableTPS = output.inServiceImpact.illustratedSalaryTPS * (1 - tpsContribution);
                        //assumed that contributions don't deduct from NI calc
                        const taxTPS = caclculateTax(salaryTaxableTPS) + calculateNI(output.inServiceImpact.illustratedSalaryTPS);
                        output.inServiceImpact.approxTakehomePayTPS = salaryTaxableTPS - taxTPS / 12;

                        if (output.inServiceImpact.approxTakehomePay < output.inServiceImpact.approxTakehomePayTPS || rollback) {
                            foundContribution = true;
                        }

                        if (!foundContribution || !rollback) {
                            if (foundContribution) {
                                output.inServiceImpact.memeberContributionPC -= 0.5;
                                output.inServiceImpact.memeberContributionPC = Math.max(10, output.inServiceImpact.memeberContributionPC);
                                rollback = true;
                                foundContribution = false;
                            } else {
                                output.inServiceImpact.memeberContributionPC += 0.5;
                            }

                            dcSalaryContribution = curSal * output.inServiceImpact.memeberContributionPC / 100 / 12 * curAccrual;
                            totalSalaryGDSTContribution = curSal * getGDSTContribution(output.inServiceImpact.memeberContributionPC) / 12 * curAccrual;
                            totalGDSTsuppliment = curSal * getGDSTSuppliment(output.inServiceImpact.memeberContributionPC) / 12 * curAccrual;
                            output.inServiceImpact.illustratedSalary = curSal / 12 / inf * curAccrual;
                            output.inServiceImpact.illustratedSalaryTPS = curSalTPS / 12 / inf * curAccrual;
                            output.inServiceImpact.memberContribution = dcSalaryContribution / inf;
                            output.inServiceImpact.gdstContribution = totalSalaryGDSTContribution / inf;
                            output.inServiceImpact.illustratedCashSuppliment = totalGDSTsuppliment / inf;
                        }

                    } while (!foundContribution || !rollback)

                    accumulationInputs.memberDCcontribution = output.inServiceImpact.memeberContributionPC;

                }

                dcPot = dcPot * Math.pow(1 + assumptions.inflation + getInvestmentReturn(accumulationVariables.investmentGrowth), 1 / 12) +
                    (dcSalaryContribution + totalSalaryGDSTContribution) * Math.pow(1 + assumptions.inflation + getInvestmentReturn(accumulationVariables.investmentGrowth), 1 / 24);

            }

        } else {

            let includeStatePension = 0;

            if (m > termToStatePensionAge) {
                includeStatePension = monthlyStatePension;
            }
            output.pensions.statePension[retirementYear] += includeStatePension / inf;

            if (m === termToRetirement) {
                // apply retirement factos
                pen60.setRetired(age);
                pen60Active.setRetired(age);
                pen80.setRetired(age);
                pen80Active.setRetired(age);
                care.setRetired(age);
                careActive.setRetired(age);

                preLumpSumTotal = pen80.retirementPensionValues.totalPension + pen60.retirementPensionValues.totalPension + care.retirementPensionValues.totalPension;
                postLumpSumTotal = preLumpSumTotal;
                preLumpSumTotalIncTPS = pen80Active.retirementPensionValues.totalPension + pen60Active.retirementPensionValues.totalPension + careActive.retirementPensionValues.totalPension;
                postLumpSumTotalIncTPS = preLumpSumTotalIncTPS;

                output.pensions.illustratedTotalDCpotAtRetirement = dcPot / inf;

                // https://www.teacherspensions.co.uk/-/media/documents/member/factsheets/applying-for-retirement/retirement-lump-sum-factsheet.ashx?rev=92045b8ea202483da8e803843919a821&hash=5D5EBC49BF8920E83C332D6B760253C2
                // dc elements at retirement
                if (retirementOptions.maxTaxFreeLumpSum) {

                    const havePostO7Only = pen80.retirementPensionValues.totalLumpSum == 0;

                    let maxLSfromPension = (pen60.retirementPensionValues.totalPension + care.retirementPensionValues.totalPension) * 30 / 7 + pen80.retirementPensionValues.totalPension * 33 / 14;
                    let maxLSfromPensionTPS = (pen60Active.retirementPensionValues.totalPension + careActive.retirementPensionValues.totalPension) * 30 / 7 + pen80Active.retirementPensionValues.totalPension * 33 / 14;
                    postLumpSumTotal -= maxLSfromPension / 12;
                    postLumpSumTotalIncTPS -= maxLSfromPensionTPS / 12;
                    output.pensions.illustratedLumpSum = (pen80.retirementPensionValues.totalLumpSum + maxLSfromPension + dcPot * 0.25) / inf;
                    output.pensions.illustratedLumpSumTPS = (pen80Active.retirementPensionValues.totalLumpSum + maxLSfromPensionTPS) / inf;

                    dcPot *= 0.75;
                } else {
                    output.pensions.illustratedLumpSum = pen80.retirementPensionValues.totalLumpSum / inf;
                    output.pensions.illustratedLumpSumTPS = pen80Active.retirementPensionValues.totalLumpSum / inf;
                }

                if (retirementOptions.illustrateDC === 'Annuity') {
                    annuityIncome = dcPot / inf / getAnnuityFactor(retAge, age_now);
                }

                output.pensions.theoreticalFutureTPSbenefitsIncStatePensionAtRetirement = Math.round((postLumpSumTotalIncTPS + monthlyStatePension * 12) / inf / 100) * 100;
                output.pensions.matchingTarget = Math.max((postLumpSumTotalIncTPS - postLumpSumTotal) / inf, 0);

            }



            output.pensions.totalDeferredTPSbenefits[retirementYear] += postLumpSumTotal / 12 / inf;
            output.pensions.theoreticalFutureTPSbenefits[retirementYear] += postLumpSumTotalIncTPS / 12 / inf;
            output.pensions.theoreticalFutureTPSbenefitsIncStatePension[retirementYear] = output.pensions.theoreticalFutureTPSbenefits[retirementYear] + output.pensions.statePension[retirementYear];

            if (retirementOptions.illustrateDC === 'Annuity') {
                output.pensions.illustratedDCincome[retirementYear] += annuityIncome / 12;
            } else {

                let requiredDraw = retirementTarget / 12;

                if (retirementOptions.drawdownType === 'Matching') {
                    requiredDraw = output.pensions.matchingTarget * inf / 12;
                }

                output.pensions.illustratedDCincome[retirementYear] += requiredDraw > dcPot ? dcPot / inf : requiredDraw / inf;

                if (requiredDraw > dcPot) {
                    dcPot = 0;
                } else {
                    dcPot = dcPot * Math.pow(1 + assumptions.inflation + getInvestmentReturn(accumulationVariables.investmentGrowth), 1 / 12) - requiredDraw * Math.pow(1 + assumptions.inflation + getInvestmentReturn(accumulationVariables.investmentGrowth), 1 / 24);
                }
            }


            if (retirementMonthCount === 12) {
                retirementMonthCount = 0;
                retirementYear++;
            }

            retirementMonthCount++;

        }

        if (m > monthsFromDataToDOC) inf *= (1 + monthlyInflation);

        datePass.add(1, "month");

    }

    if (pen60.status == 'Active') output.retireInConsultation = true;

    output.pensions.remainingDCPot = dcPot / inf;

    return output;
}

export default {
    calculateBenefits,
    calculateConstraints,
    version,
}